/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useCallback, useState } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

const withOnHoverStuffHOCGenerator = (Component, settings = {}) => {
  function WithOnHoverHOC(props) {
    const [isHovered, setIsHovered] = useState(false);
    const updateHovered = useCallback(
      debounce((value) => {
        setIsHovered(value);
      }, settings.debounceTime || 200),
      []
    );

    const onMouseEnterHandler = useCallback(() => {
      props.onMouseEnterHandler?.();
      updateHovered(true);
    }, [props.onMouseEnterHandler, props.updateHovered]);

    const onMouseLeaveHandler = useCallback(() => {
      props.onMouseLeaveHandler?.();
      updateHovered(false);
    }, [props.onMouseLeaveHandler, props.updateHovered]);

    return (
      <Component {...props} isHovered={isHovered} onMouseLeaveHandler={onMouseLeaveHandler} onMouseEnterHandler={onMouseEnterHandler} />
    );
  }

  WithOnHoverHOC.propTypes = {
    onMouseLeaveHandler: PropTypes.func,
    onMouseEnterHandler: PropTypes.func,
    updateHovered: PropTypes.func,
  };

  return WithOnHoverHOC;
};

const withOnHoverStuff = () => (Component) => withOnHoverStuffHOCGenerator(Component);

export default withOnHoverStuff;

export function useWithHover() {
  const [isHovered, setHovered] = useState(false);

  return [
    isHovered,
    function onMouseEnterHandler() {
      setHovered(true);
    },
    function onMouseLeaveHandler() {
      setHovered(false);
    },
  ];
}
